<template>
  <div class="container">
    <div class="header right">
      <h1>{{ headerText }}</h1>
      <div class="underline"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['headerText']
}
</script>

<style scoped>
  @import url('../../../static/css/components-style/header.css');
</style>



// WEBPACK FOOTER //
// src/components/COMMON/Header.vue